export default __webpack_public_path__ + "static/media/Shopping-Cart.68a54c35.jpg";